import { Badge as ChakraBadge, BadgeProps } from '@chakra-ui/react';

export type BADGE_COLORS =
  | 'lightOrange'
  | 'lightPurple'
  | 'lightBlue'
  | 'lightYellow'
  | 'lightRed'
  | 'lightGray'
  | 'lightGreen'
  | 'blue'
  | 'gray'
  | 'darkGray'
  | 'green'
  | 'orange'
  | 'red'
  | 'black'
  | 'white'
  | string;

export const Badge = ({
  children,
  dataTestid = '',
  textTransform = 'none',
  ...props
}: BadgeProps & {
  dataTestid?: string;
  textTransform?: string;
}) => (
  <ChakraBadge
    data-testid={dataTestid}
    textTransform={textTransform}
    {...props}
  >
    {children}
  </ChakraBadge>
);
